import {
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const getBinInventory = {
  name: "getBinInventory" as const,
  input: z.object({ storageLocationId: storageLocationIdFormat.schema }),
  output: z.object({
    items: z.array(
      z.object({
        productId: productIdFormat.schema,
        title: z.string(),
        sku: z.string().nullable(),
        imageUrl: z.string().nullable(),
        quantity: z.number(),
        lastCountedAt: z.string().nullable(),
      }),
    ),
  }),
};
